import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=f5a152ba&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"
import style0 from "./Survey.vue?vue&type=style&index=0&id=f5a152ba&prod&scoped=true&lang=css"
import style1 from "./Survey.vue?vue&type=style&index=1&id=f5a152ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a152ba",
  null
  
)

export default component.exports